import styled from "styled-components";

const getPaddingLeft = (level, type) => {
  let paddingLeft = level * 28;
  if (type === "file") paddingLeft += 30;
  return paddingLeft;
};

export const StyledTreeNode = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: 5px 8px;
  padding-left: ${props => getPaddingLeft(props.level, props.type)}px;
  ${({ selectedForCopy }) => selectedForCopy && `
    background: rgba(111,169,193, 0.2);
  `}
`;

export const NodeIcon = styled.div`
  font-size: 12px;
  margin-right: ${props => (props.marginRight ? props.marginRight : 5)}px;
  ${({ selectedForCopy }) => selectedForCopy && `
      color: rgba(0,0,0, 0.5);
  `}
`;

export const LeafName = styled.div`
  &:hover {
    text-decoration: underline;
  }
  cursor: pointer;
  ${({ selectedForCopy }) => selectedForCopy && `
    color: rgba(0,0,0, 0.5);
  `}
`;


export const BranchName = styled.div`
  ${({ selectedForCopy }) => selectedForCopy && `
      color: rgba(0,0,0, 0.5);
  `}
`;

export const OptionButtonContainer = styled.span`
  display: flex,
  flex-direction: 'row',
  align-items: 'center',
`;
